module.exports = __webpack_public_path__ + "img/02.56fa7e9e.png";